export const loginFormModalInit = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const body = document.querySelector('body');
    const openModalBtn = document.querySelector('#loginFormOpen');
    const closeModalBtn = document.querySelector('#loginFormClose');
    const loginFormModal = document.querySelector('.customCheckoutPage__loginForm');

    if(openModalBtn) {
      openModalBtn.addEventListener('click', (e) => {
        loginFormModal.showModal();
        body.classList.add('modal-open');
        body.style.overflow = 'hidden';
      });
    }

    if(closeModalBtn) {
      closeModalBtn.addEventListener('click', (e) => {
        loginFormModal.close();
        body.classList.remove('modal-open');
        body.style.overflow = 'auto';
      });
    }
  });
}